export default "__VITE_PUBLIC_ASSET__bfcb8738__"